import React, { forwardRef, useLayoutEffect, useState } from "react";
import {
  GridPanel,
  type GridPanelProps,
  GridPreferencePanelsValue,
  gridPreferencePanelStateSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-premium";

const GRID_PANEL_ANCHOR_SELECTOR = '[data-id="gridPanelAnchor"]';

/** Keeps the filter panel anchored to the grid top-left (not the toolbar filter button). */
export const RegulationsGridPanel = forwardRef<
  HTMLDivElement,
  GridPanelProps
>(function RegulationsGridPanel(props, ref) {
  const apiRef = useGridApiContext();
  const preferencePanelState = useGridSelector(
    apiRef,
    gridPreferencePanelStateSelector,
  );
  const [filterPanelAnchorTarget, setFilterPanelAnchorTarget] =
    useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    const anchor = apiRef.current?.rootElementRef?.current?.querySelector(
      GRID_PANEL_ANCHOR_SELECTOR,
    ) as HTMLElement | null;
    setFilterPanelAnchorTarget(anchor);
  }, [apiRef, preferencePanelState.open]);

  const isFilterPanelOpen =
    preferencePanelState.openedPanelValue === GridPreferencePanelsValue.filters;

  const target = isFilterPanelOpen
    ? (filterPanelAnchorTarget ?? props.target)
    : props.target;

  return (
    <GridPanel
      {...props}
      ref={ref}
      target={target}
      flip={isFilterPanelOpen ? false : props.flip}
    />
  );
});
